import React, { Component } from 'react';
import { Route } from 'react-router';
/*
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants'; */


// Components 
import { Layout } from './components/shared/Layout';
import { Footer } from './components';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';

import Home from './views/Home';
import GestioneLicenze from './views/GestioneLicenze'; 
import Statistiche from './views/Statistiche';
import LogAccessi from './views/LogAccessi';
import LogLicenze from './views/LogLicenze';

// settings
//import { routes } from './settings/app-routes';
import appInfo from './settings/app-info';

// css
import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import './styles/App.scss';
import './styles/dx-styles.scss';
import { sizes, screenSubscribe, screenUnsubscribe } from './utils/media-query';

//css default
import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = {
            screenSizeClass: this.getScreenSizeClass()
        };
    }

    componentDidMount() {
        screenSubscribe(this.screenSizeChanged);
    }

    componentWillUnmount() {
        screenUnsubscribe(this.screenSizeChanged);
    }

    getScreenSizeClass() {
        const screenSizes = sizes();
        return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
    }

    screenSizeChanged = () => {
        this.setState({
            screenSizeClass: this.getScreenSizeClass()
        });
    }

    render() {
        return (
            <div className={`app ${this.state.screenSizeClass}`}>
                <SideNavBarLayout title={appInfo.title} >
                    <Layout>
                        <Route exact path='/' component={Home} />
                        <Route path='/gestione-licenze' component={GestioneLicenze} />
                        <Route path='/statistiche' component={Statistiche} />
                        <Route path='/log-accessi' component={LogAccessi} />
                        <Route path='/log-licenze' component={LogLicenze} />
                    </Layout>
                    <Footer>
                        Copyright &copy; 2020 L@ZIENDALE
                    </Footer>
                </SideNavBarLayout>
            </div>
        );
    }
}
